import type { AddTaskPayload } from './types';
import { TradingAddTaskCommands } from './types';
import { wsEsSend } from '@skynet/data-ws-es';
import { createAppAsyncThunk } from 'src/store/utils/thunks';

export const addTask = createAppAsyncThunk(
  'tradingAddTaskActions/addTask',
  (data: AddTaskPayload, thunkApi) =>
    thunkApi.dispatch(
      wsEsSend({
        command: TradingAddTaskCommands.AddTask,
        ...data,
      }),
    ),
);
